import {
  VALIDATION_IDENTIFIER,
  VALIDATION_IDENTIFIER_MSG_EMPTY,
  VALIDATION_IDENTIFIER_MSG_INVALID
} from './constants'

export default function validateIdentifier(value) {
  const validate = !VALIDATION_IDENTIFIER.test(value)
    ? VALIDATION_IDENTIFIER_MSG_INVALID
    : undefined
  return !value ? VALIDATION_IDENTIFIER_MSG_EMPTY : validate
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/identifierValidate.js